import _jsx from "@babel/runtime/helpers/jsx";

var _SeoTextsBlocks, _SeoLinksBlocks, _BreadCrumbsWrapper;

import React, { memo } from 'react';
import SeoTextsBlocks from 'components/SeoTextsBlocks';
import SeoLinksBlocks from 'components/SeoLinksBlocks';
import PageBreadCrumbs from 'components/PageBreadCrumbs';
import { Footer } from 'components/FooterStyles';
import { BreadCrumbsWrapper } from './styles';

function PageFooter(_ref) {
  var isShowTextBlocks = _ref.isShowTextBlocks,
      isShowBreadcrumbs = _ref.isShowBreadcrumbs;
  return /*#__PURE__*/_jsx(Footer, {}, void 0, isShowTextBlocks && (_SeoTextsBlocks || (_SeoTextsBlocks = /*#__PURE__*/_jsx(SeoTextsBlocks, {}))), _SeoLinksBlocks || (_SeoLinksBlocks = /*#__PURE__*/_jsx(SeoLinksBlocks, {})), isShowBreadcrumbs && (_BreadCrumbsWrapper || (_BreadCrumbsWrapper = /*#__PURE__*/_jsx(BreadCrumbsWrapper, {}, void 0, /*#__PURE__*/_jsx(PageBreadCrumbs, {})))));
}

PageFooter.defaultProps = {
  isShowBreadcrumbs: true,
  isShowTextBlocks: false
};
export default /*#__PURE__*/memo(PageFooter);